import { Chip } from "@mui/material"
import { StyledTableCell } from "../../pages/NftBoxesTurretsPage"
import { styled } from "@mui/material/styles"
import TableRow from "@mui/material/TableRow"

export const RarityItem = ({ level, probability, amount }) => {
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&": {
      borderBottom: "1px solid transparent",
      borderImage:
        "url(static/media/divider-primary-gradient.65b426a8.svg) 1 stretch",
    },
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }))

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Chip label={level} className={`chip chip-${level.toLowerCase()}`} />
      </StyledTableCell>
      <StyledTableCell>
        <span>{probability}</span>
      </StyledTableCell>
      <StyledTableCell>
        <span>{amount}</span>
      </StyledTableCell>
    </StyledTableRow>
  )
}
